var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showModal)?_c('Modal',{attrs:{"id":"popup-system-notice","title":_vm.systemNotice.title,"active":_vm.isOpen},on:{"update:active":function($event){_vm.isOpen=$event},"close":_vm.dontShowAgain}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.systemNotice.html)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }